<template>
    <PopupRouterViewDetail label="Finish Good Quality Inspection Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Finish Good Quality Inspection" class="mb-3">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData"  :isEditable="false" :isUpdatable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
						<app-input-textbox id="fieldset-qty-before" label-cols-lg="12"  label="Qty Before" label-for="input-qty-before" size="sm" :model.sync="model.qtyBefore"  @change="updateData"  :isEditable="false" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="model.qtyAfter"  @change="updateData"  :isEditable="false" />
						<app-input-textbox id="fieldset-qty-pending" label-cols-lg="12"  label="Qty Pending" label-for="input-qty-pending" size="sm" :model.sync="model.qtyPending"  @change="updateData"  :isEditable="false" />
						<app-input-textbox id="fieldset-qty-ng" label-cols-lg="12"  label="Qty Ng" label-for="input-qty-ng" size="sm" :model.sync="model.qtyNg"  @change="updateData"  :isEditable="false" />
						<app-input-radio :options="metodeQcs" text-field="name" value-field="id" label-cols-lg="12" label="Metode Qc" id="fieldset-metode-qc" size="sm" :model.sync="model.metodeQcId"  @change="updateData"  :isEditable="false" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Finish Good Quality Inspection Ng" :bordered="true" :items="finishGoodQualityInspectionNgs" :fields="fieldsFinishGoodQualityInspectionNg" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQualityInspectionNg" :sort-desc.sync="sortDescFinishGoodQualityInspectionNg" small responsive
			@editButtonMethod="editRowDataFinishGoodQualityInspectionNg"
			@deleteButtonMethod="deleteRowDataFinishGoodQualityInspectionNg"
			@showPopupAddMethod="resetDataFinishGoodQualityInspectionNg()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQualityInspectionNg()"
			@downloadMethod="downloadFinishGoodQualityInspectionNg()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQualityInspectionNg()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQualityInspectionNg()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQualityInspectionNg"
			>
			<template #top-row v-if="isShowFinishGoodQualityInspectionNgFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Problem Category">
					<v-select append-to-body label="code" :options="problemCategorys"  :value="filterFinishGoodQualityInspectionNg.problemCategoryId" :reduce="item => item.id" v-model="filterFinishGoodQualityInspectionNg.problemCategoryId" @search="getProblemCategorys" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Qty Ng">
					<b-form-input id="input-qty-ng-table" v-model="filterFinishGoodQualityInspectionNg.qtyNg" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQualityInspectionNgPageSize * (currentFinishGoodQualityInspectionNgPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(problemCategory)="row">
				<app-input-combobox-autocomplete :options="problemCategorys" optionsLabel="code" optionsKey="id" :id="'input-finish-good-quality-inspection-ng-problem-category-' + row.index" label-cols-lg="12" label="Problem Category" size="sm" :model.sync="row.item.problemCategoryId" :state="validateState('problemCategoryId')" :errorMessage="getErrorMessage(errorMessage.problemCategoryId, 'problemCategoryId')"  @change="saveInputFinishGoodQualityInspectionNg(row.item)" :selected="row.item.problemCategory != null ? row.item.problemCategory.code : ''"  @input="getProblemCategorys" :loading="isProblemCategoryComboLoading"   :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index" label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg"   @change="saveInputFinishGoodQualityInspectionNg(row.item)"  :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<FinishGoodQualityInspectionNgInput 
					:openPopup="isShowPopupFinishGoodQualityInspectionNg"
					:modelId="finishGoodQualityInspectionNgId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQualityInspectionNg"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQualityInspectionNgUpload
					:openPopup="isShowPopupUploadFinishGoodQualityInspectionNg"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQualityInspectionNg"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-finish-good-quality-inspection-ng-qty-ng-' + row.index" label-cols-lg="12" label="Qty Ng" size="sm" :model.sync="row.item.qtyNg"   @change="saveInputFinishGoodQualityInspectionNg(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-left-button>
			<b-button size="sm" class="float-right btn-outline-success mr-1" @click="printCard" v-if="model.qtyPending > 0">Print Card</b-button>
		</template>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionList from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionList';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputRadio from '@/components/AppInputRadio';
import MetodeQc from '@/models/MetodeQc/MetodeQc';
import MetodeQcFilter from '@/filters/MetodeQc/MetodeQcFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import WorkOrderProcessDetail from '@/models/WorkOrderProcess/WorkOrderProcessDetail';
import WorkOrderProcessDetailFilter from '@/filters/WorkOrderProcess/WorkOrderProcessDetailFilter';
import FinishGoodQualityInspectionNg from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspectionNg';
import FinishGoodQualityInspectionNgFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionNgFilter';
import ProblemCategory from '@/models/ProblemCategory/ProblemCategory';
import ProblemCategoryFilter from '@/filters/ProblemCategory/ProblemCategoryFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQualityInspectionNgInput from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgInput';
import FinishGoodQualityInspectionNgUpload from '@/views/FinishGoodQualityInspection/FinishGoodQualityInspectionNgUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputRadio,
		FinishGoodQualityInspectionNgInput,FinishGoodQualityInspectionNgUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsFinishGoodQualityInspectionNg: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"problemCategory": { "class" : "th-problem-category first-child", "label" : "Problem Category", key: 'problemCategory', sortable: false}}, 
				{"qtyNg": { "class" : "th-qty-ng", "label" : "Qty Ng", key: 'qtyNg', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelFinishGoodQualityInspectionNg : {},
			isShowPopupFinishGoodQualityInspectionNg : false,
			isShowPopupUploadFinishGoodQualityInspectionNg : false,
			filterFinishGoodQualityInspection : null,
			currentFinishGoodQualityInspectionPage : 1,
			finishGoodQualityInspectionPageSize: 10,
			sortByFinishGoodQualityInspection: '',
			sortDescFinishGoodQualityInspection: '',
			filterFinishGoodQualityInspectionNg : null,
			currentFinishGoodQualityInspectionNgPage : 1,
			finishGoodQualityInspectionNgPageSize: 10,
			sortByFinishGoodQualityInspectionNg: '',
			sortDescFinishGoodQualityInspectionNg: '',
			sortingByFinishGoodQualityInspectionNg: [],
			finishGoodQualityInspectionNgs : [],
			finishGoodQualityInspectionNgId : '',
			totalFinishGoodQualityInspectionNgRow : 0,
			isShowFinishGoodQualityInspectionNgFilter: false,
			isDownloadFinishGoodQualityInspectionNg: false,
			problemCategorys: [],
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			metodeQcs: [],
			metodeQcs: [],
			isMetodeQcComboLoading: false,
			parts: [],
			parts: [],
			isPartComboLoading: false,
			workOrderProcessDetails: [],
			workOrderProcessDetails: [],
			isWorkOrderProcessDetailComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
			isMetodeQcComboLoading: false,
			isPartComboLoading: false,
			isWorkOrderProcessDetailComboLoading: false,
			isFinishGoodQualityInspectionComboLoading: false,
			isProblemCategoryComboLoading: false,
		}
	},
	methods : {
		async printCard(){
			this.isBusy = true;
			let controlCardId = this.model != null ? this.model.controlCardId : 0;
			// console.log('controlCardId',controlCardId)
			try {
				let ids = [];
				ids.push(controlCardId);
				let result = await ControlCard.printControlCard(this_, ids);
				this.toast({message: "Print Card berhasil", variant:"success", title: "Success" })
				this.isBusy = false;
			} catch {
				this.isBusy = false;
			}
		},
		getFinishGoodQualityInspection : async function(id) {
			this.isBusy = true;
			FinishGoodQualityInspection.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQualityInspection = true;
			this.filterFinishGoodQualityInspection.id = this.modelId;
			FinishGoodQualityInspection.downloadDataDetail(this, this.filterFinishGoodQualityInspection).then(result => {
				this.isDownloadFinishGoodQualityInspection = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspection = false; })
		},
		getFinishGoodQualityInspectionNgs : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQualityInspectionNg);
			if (this.modelId == null) return;
			filter.finishGoodQualityInspectionId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByFinishGoodQualityInspectionNg != null) {
				this.sortingByFinishGoodQualityInspectionNg[this.sortByFinishGoodQualityInspectionNg] = this.sortDescFinishGoodQualityInspectionNg;
			}
			let currentPage = (this.currentFinishGoodQualityInspectionNgPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQualityInspectionNgRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQualityInspectionNgPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQualityInspectionNgPageSize = 0;
			// disable paging end
			FinishGoodQualityInspectionNg.getList(this, filter, this.sortingByFinishGoodQualityInspectionNg, currentPage , this.finishGoodQualityInspectionNgPageSize).then(result => {
				this.currentFinishGoodQualityInspectionNgPage = currentPage + 1;
				this.finishGoodQualityInspectionNgs = result.data;
				this.totalFinishGoodQualityInspectionNgRow = result.dataCount;
			}).catch(error => {});
		},
		getFinishGoodQualityInspections : async function(input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspections = result.data
				}
				this.isFinishGoodQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQualityInspections : async function(input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspections = result.data
				}
				this.isFinishGoodQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getProblemCategorys : async function(input) {
			let filter = new ProblemCategoryFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isProblemCategoryComboLoading = true;
			ProblemCategory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.problemCategorys = result.data
				}
				this.isProblemCategoryComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCard(item) {
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getMetodeQcs : async function(input) {
			let filter = new MetodeQcFilter();
			if (input != undefined) {
				filter.name = input;
			}
			MetodeQc.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.metodeQcs = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedMetodeQc(item) {
			if(item == undefined || item == null) {
				this.model.metodeQcId = null;
				this.model.metodeQc = null;
			} else {
				this.model.metodeQcId = item.id;
				this.model.metodeQc = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcessDetails : async function(input) {
			let filter = new WorkOrderProcessDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			WorkOrderProcessDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderProcessDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderProcessDetail(item) {
			if(item == undefined || item == null) {
				this.model.workOrderProcessDetailId = null;
				this.model.workOrderProcessDetail = null;
			} else {
				this.model.workOrderProcessDetailId = item.id;
				this.model.workOrderProcessDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.finishGoodQualityInspectionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspection.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					FinishGoodQualityInspection.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqualityinspectionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspection.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getFinishGoodQualityInspection(id);
					});
				}
			});
		},
		onHidden() {
			this.getFinishGoodQualityInspections();
		},
		addRowDataFinishGoodQualityInspectionNg(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQualityInspectionId =  this.modelId;
					FinishGoodQualityInspectionNg.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQualityInspectionNgs(true);
						this.isShowPopupFinishGoodQualityInspectionNg = false;
					})
				} else {
					model.finishGoodQualityInspectionId =  this.modelId;
					FinishGoodQualityInspectionNg.createDataDetail(this, model)
					.then(result => {
						this.getFinishGoodQualityInspectionNgs(true);
						this.isShowPopupFinishGoodQualityInspectionNg = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQualityInspectionNg(id) {
			this.finishGoodQualityInspectionNgId = id;
			this.isShowPopupFinishGoodQualityInspectionNg = true; 
		},
		async deleteRowDataFinishGoodQualityInspectionNg(id) {
			FinishGoodQualityInspectionNg.deleteData(this, id).then(result => { this.getFinishGoodQualityInspectionNgs(); });
		},
		async resetDataFinishGoodQualityInspectionNg() {
			this.finishGoodQualityInspectionNgId = "";
			this.isShowPopupFinishGoodQualityInspectionNg = true;
		},
		async addDataFinishGoodQualityInspectionNg() {
			FinishGoodQualityInspectionNg.createData(this, { finishGoodQualityInspectionId: this.modelId })
			.then(result => {
				this.getFinishGoodQualityInspectionNgs(true);
			})
		},
		async addFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.addFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});
		},
		async replaceFromClipboardFinishGoodQualityInspectionNg() {
			let problemCategorys = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					problemCategorys.push({ problemCategory: item, finishGoodQualityInspectionId: this.modelId });
				});
				FinishGoodQualityInspectionNg.replaceFromClipboard(this, problemCategorys).then(result => { this.getFinishGoodQualityInspectionNgs() });
			});   
		},
		showPopupUploadFinishGoodQualityInspectionNg() {
			if(this.finishGoodQualityInspectionNgs != null && this.finishGoodQualityInspectionNgs.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap FinishGoodQualityInspectionNg akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadFinishGoodQualityInspectionNg = true;
			}
		},
		uploadDataFinishGoodQualityInspectionNg(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false; 
		},
		downloadFinishGoodQualityInspectionNg(modalEvent) {
			this.isDownloadFinishGoodQualityInspectionNg = true;
			this.filterFinishGoodQualityInspectionNg.finishGoodQualityInspectionId = this.modelId;
			FinishGoodQualityInspectionNg.downloadDataDetail(this, this.filterFinishGoodQualityInspectionNg).then(result => {
				this.isDownloadFinishGoodQualityInspectionNg = false;
			}).catch(error => { this.isDownloadFinishGoodQualityInspectionNg = false; })
		},
		saveInputFinishGoodQualityInspectionNg(item) {
			if (this.finishGoodQualityInspections != null && this.finishGoodQualityInspections != undefined  && this.finishGoodQualityInspections.length > 0) {
				item.finishGoodQualityInspection = this.finishGoodQualityInspections.find(q => q.id == item.finishGoodQualityInspectionId);
			}
			if (this.problemCategorys != null && this.problemCategorys != undefined  && this.problemCategorys.length > 0) {
				item.problemCategory = this.problemCategorys.find(q => q.id == item.problemCategoryId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQualityInspectionNg.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQualityInspectionNg = false; 
			this.isShowPopupFinishGoodQualityInspectionNg = false; 
			if (modalType == 'FinishGoodQualityInspectionNg') {
				this.getFinishGoodQualityInspectionNgs();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowFinishGoodQualityInspectionNgFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterFinishGoodQualityInspection = new FinishGoodQualityInspectionFilter();
		this.filterFinishGoodQualityInspectionNg = new FinishGoodQualityInspectionNgFilter();
		//this.getFinishGoodQualityInspections();
		//this.getProblemCategorys();
		//this.getControlCards();
		this.getMetodeQcs();
		//this.getParts();
		//this.getWorkOrderProcessDetails();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getFinishGoodQualityInspection(id);
				this.getFinishGoodQualityInspectionNgs();
			} else {
				this.modelId = id;
				this.getFinishGoodQualityInspection(id);
				this.getFinishGoodQualityInspectionNgs();
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByFinishGoodQualityInspectionNg : {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		sortDescFinishGoodQualityInspectionNg: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		currentFinishGoodQualityInspectionNgPage: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		finishGoodQualityInspectionNgPageSize : {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			}
		},
		filterFinishGoodQualityInspectionNg: {
			handler: function() {
				this.getFinishGoodQualityInspectionNgs();
			},
			deep: true,
		},
	},
}
</script>
